angular.module('iconoglobe').directive('lightBox', ["$uibModal", "$rootScope", function($uibModal, $rootScope){
  return {
    scope: "=",
    controller: function ($scope) {
      $scope.photos = [];
      $scope.pos = 0;
      $scope.open = function(photos, current, wclass){
        $scope.photos = [];
        if(!photos[0].name){
          for(var i=0; i < photos.length; i++){
            $scope.photos.push({name: photos[i]});
          }
        } else{
          $scope.photos = photos;
        }
        $scope.pos = current;
        $scope.currentImage = $scope.photos[$scope.pos];
        $scope.modalInstance = $uibModal.open({
          animation: true,
          templateUrl: 'app/min/lightbox.html',
          //windowClass: 'zindexModal int129',
          scope: $scope,
          windowClass : "zindexModal int130 lightbox-modal " + wclass
        });
        $scope.modalInstance.result.then(function (selectedItem) {
          $scope.close();
          $scope.photos = [];
        }, function () {
          $scope.photos = [];
          console.log('data')    
        });
      }
      $scope.close = function(){
        $scope.modalInstance.dismiss();
      }
      $scope.nextImage = function(){
        if(($scope.photos.length - 1) > $scope.pos){
          $scope.pos++;
        } else {
          $scope.pos = 0;
        }
        $scope.currentImage = $scope.photos[$scope.pos];
      }
      
      $scope.prevImage = function(){
        if($scope.pos > 0){
          $scope.pos--;
        } else {
          $scope.pos = $scope.photos.length - 1;
          
        }
        $scope.currentImage = $scope.photos[$scope.pos];
      }
    }
  }
}]);